/**
 * ExecutionContext — 节点执行状态 Context
 * 
 * 从 ProjectStudio.tsx 提取出来，供所有 Flow 节点组件共享。
 * ProjectStudio.tsx 中的 ExecutionContext.Provider 提供值，
 * 各节点组件通过 useContext(ExecutionContext) 消费。
 */
import { createContext } from 'react'
import type { SceneConfig } from '@/modules/identity/services/identity-api'

export type { SceneConfig }

export interface ExecutionContextType {
  activeNodeId: string | null
  visitedNodeIds: Set<string>
  sceneConfigs: SceneConfig[]
}

export const ExecutionContext = createContext<ExecutionContextType>({
  activeNodeId: null,
  visitedNodeIds: new Set(),
  sceneConfigs: [],
})
